import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionSharedDataService } from 'src/app/services/session-shared-data.service';
import {
  NotificationIconConfig,
  NotificationIconTypes,
  NotificationToasterService,
  NotificationType,
  V2NotificationData,
  V2NotificationDataBuilder,
} from 'src/app/services/notification-toaster.service';
import { WAITING_ROOM } from 'src/app/common/utils/notification-constants';
import { ToastrService } from 'ngx-toastr';
import { AclService } from 'src/app/services/acl.service';
import { ToasterPopupStyle } from 'src/app/ui/notification-toaster/custom-notification-toastr/custom-notification-toastr.component';
import { IconBackground } from 'src/app/ui/notification-toaster/icon-message-toaster-element/icon-message-toaster-element.component';
import { AudioService } from 'src/app/services/audio.service';
import { CustomerSupportService } from 'src/app/services/customer-support.service';
import { UserService } from 'src/app/services/user.service';
import { RequestAccessNotificationBaseService } from '../base/request-access-notifications-base.service';
@Injectable({
  providedIn: 'root',
})
export class WaitingRoomNotificationService extends RequestAccessNotificationBaseService {
  protected notificationCode: string;
  protected warningCode: string;
  protected errorCode: string;

  protected acceptButtontext: string;
  protected acceptAllButtontext: string;
  protected singleRequestNotificationText: string;
  protected multiRequestsNotificationText: string;
  protected msg: string;
  protected defaultNotificationIconName: string;

  private hostSentYouToWRNotification!: V2NotificationData;

  constructor(
    protected sessionSharedDataService: SessionSharedDataService,
    protected translateService: TranslateService,
    protected notificationToasterService: NotificationToasterService,
    protected toastr: ToastrService,
    protected aclService: AclService,
    protected audioService: AudioService,
    protected customerSupportService: CustomerSupportService,
    protected userService: UserService,
  ) {
    super(
      sessionSharedDataService,
      translateService,
      notificationToasterService,
      toastr,
      aclService,
      audioService,
      customerSupportService,
      userService,
    );

    this.notificationCode = WAITING_ROOM.WAITING_ROOM_REQUEST_NOTIFICATION;
    this.warningCode = WAITING_ROOM.WAITING_ROOM_WARNING;
    this.errorCode = WAITING_ROOM.WAITING_ROOM_ERROR;

    this.acceptButtontext = this.translateService.instant('Admit');
    this.acceptAllButtontext = this.translateService.instant('Admit All');
    this.singleRequestNotificationText = this.translateService.instant('is in the Waiting Room');
    this.multiRequestsNotificationText = this.translateService.instant(
      'users are in the Waiting Room',
    );
    this.msg = this.translateService.instant('You can review them in Participant Manager.');
    this.defaultNotificationIconName = 'access_requests_clock_black';
  }

  showHostMovedYouToWRNotification() {
    if (!this.hostSentYouToWRNotification) {
      this.buildHostSentYouToWRNotification();
    }

    this.notificationToasterService.showNotification(this.hostSentYouToWRNotification);
  }

  private buildHostSentYouToWRNotification() {
    const notificationIcon: NotificationIconConfig = {
      assetName: 'access_requests_clock_black',
      type: NotificationIconTypes.SVG_ICON,
      width: 18,
      height: 18,
      background: IconBackground.INFO,
    };

    const notificationTitle = this.translateService.instant('You were sent to the Waiting Room.');

    this.hostSentYouToWRNotification = new V2NotificationDataBuilder(
      WAITING_ROOM.HOST_SENT_YOU_TO_WR_NOTIFICATION,
    )
      .type(NotificationType.WARNING)
      .style(ToasterPopupStyle.WARN)
      .title(notificationTitle)
      .icon(notificationIcon)
      .showProgressBar(false)
      .dismissable(true)
      .priority(600)
      .build();
  }

  dismissHostSentYouToWRNotification() {
    this.notificationToasterService.dismissNotificationsByCode([
      WAITING_ROOM.HOST_SENT_YOU_TO_WR_NOTIFICATION,
    ]);
  }
}
